
const digest = '8ca44a5df8851e316fb40979537e88911676b256d8a9aa2471c2ea8441eb5e4e';
const classes = {"upload":"_upload_jm0kx_1","file":"_file_jm0kx_10","title":"_title_jm0kx_17","name":"_name_jm0kx_22","buttonWrapper":"_buttonWrapper_jm0kx_32","button":"_button_jm0kx_32","hint":"_hint_jm0kx_42","inputWrapper":"_inputWrapper_jm0kx_51"};
const css = `._upload_jm0kx_1 {
  background-color: #f2f4f7;
  padding: 36px 24px;
  margin: -34px -24px 24px -24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._upload_jm0kx_1 ._file_jm0kx_10 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}
._upload_jm0kx_1 ._file_jm0kx_10 ._title_jm0kx_17 {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}
._upload_jm0kx_1 ._file_jm0kx_10 ._name_jm0kx_22 {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  background-image: url("/dist/icons/delete-icon.svg");
  background-repeat: no-repeat;
  padding-right: 20px;
  background-position: center right;
  word-break: break-word;
}
._upload_jm0kx_1 ._buttonWrapper_jm0kx_32 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._upload_jm0kx_1 ._buttonWrapper_jm0kx_32 ._button_jm0kx_32 {
  min-width: fit-content;
  height: fit-content;
}
._upload_jm0kx_1 ._buttonWrapper_jm0kx_32 ._hint_jm0kx_42 {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  flex-grow: 1;
  text-align: left;
  padding: 0 24px;
}

._inputWrapper_jm0kx_51 {
  display: none;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  